import { Routes } from '@angular/router';
import { mustChangePasswordGuard } from '@nebula-shared/data-access';
import { CambiarClaveComponent } from './cambiar-clave.component';

/**
 * Ruta de cambio de contraseña vencida. Protegida por {@link mustChangePasswordGuard}: solo
 * accesible si hay sesión válida y un cambio pendiente (se llega desde el login).
 */
export const CAMBIAR_CLAVE_ROUTES: Routes = [
  {
    path: '',
    component: CambiarClaveComponent,
    canActivate: [mustChangePasswordGuard],
  },
];
